import * as React from 'react';

export interface GridContextGridProps {
  columns: number;
  columnGap: number;
}

export interface GridContextProps {
  grid: GridContextGridProps;
}

export const GridContext = React.createContext<GridContextGridProps>({ columns: 12, columnGap: 5 });

export function withGridContext<P>(Component: React.ComponentType<P & GridContextProps>): React.SFC<P> {
  return (props: P) => {
    return (
      <GridContext.Consumer>
        {(value: GridContextGridProps) => <Component grid={value} {...props} />}
      </GridContext.Consumer>
    );
  };
}
